import React, { Component } from 'react';

import { Form } from 'react-bootstrap';

import * as util from '../../library/utilitys';

/** current modify */
class CommonCheckbox extends Component {
    render = () => {
        let props = this.props;

        let input = props?.input || {};
        let checkbox = props?.checkbox || {}; 

        let { display = "inline", label, inputs = [], validator, error } = checkbox;
        
        let { element, callback, disabled = false, hr = false, size = "md" } = props;

        let isInline = element === 'Searchs' ? true : checkbox?.display === "inline";

        return (
            <>
                <Form.Group>
                    <div className={isInline ? "d-inline-flex flex-wrap gap-3 align-items-center" : "d-flex flex-column"}>
                        {element === 'Inputs' && label && (
                            <Form.Label className={`me-2 mb-0 ${size === 'sm' ? 'label-size-sm' : ''}`}>
                                {label} {validator?.required && <span>*</span>}
                            </Form.Label>
                        )}

                        {inputs.map((item) => {
                            const itemInput = input[item.id] || {};
                            return (
                                <Form.Check
                                    key={`${element}_${itemInput.id}_${item.id}`}
                                    type="checkbox"
                                    id={`${element}_${itemInput.id}_${item.id}`}
                                    name={`${element}_${itemInput.id}`}
                                    label={itemInput.label}
                                    value={item.value}
                                    checked={itemInput.value === item.value}
                                    inline={true}
                                    onChange={(e) => callback(e, element)}
                                    disabled={disabled}
                                    className={size === 'sm' ? 'checkbox-sm' : ''}
                                />
                            );
                        })}
                    </div>
                </Form.Group>

                {(element === 'Inputs' && error?.status) && (
                    <div className="invalid-feedback d-block mt-2 ms-2" style={{ fontSize: '0.75rem' }}>
                        <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-1" />
                        {error?.msg}
                    </div>
                )}

                {hr && <hr className="hr-custom" />}
            </>
        );
    };
}

export default CommonCheckbox;
